var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2021_411)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2021_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49725 6.2519C9.53799 6.29254 9.57032 6.34081 9.59237 6.39397C9.61443 6.44712 9.62578 6.5041 9.62578 6.56165C9.62578 6.61919 9.61443 6.67617 9.59237 6.72932C9.57032 6.78248 9.53799 6.83076 9.49725 6.8714L6.87225 9.4964C6.83161 9.53714 6.78333 9.56946 6.73018 9.59152C6.67703 9.61357 6.62005 9.62493 6.5625 9.62493C6.50495 9.62493 6.44797 9.61357 6.39482 9.59152C6.34167 9.56946 6.29339 9.53714 6.25275 9.4964L4.94025 8.1839C4.89957 8.14322 4.86731 8.09493 4.84529 8.04178C4.82328 7.98863 4.81195 7.93167 4.81195 7.87415C4.81195 7.81662 4.82328 7.75966 4.84529 7.70651C4.86731 7.65336 4.89957 7.60507 4.94025 7.5644C5.0224 7.48224 5.13382 7.43609 5.25 7.43609C5.30753 7.43609 5.36449 7.44742 5.41764 7.46944C5.47078 7.49145 5.51907 7.52372 5.55975 7.5644L6.5625 8.56802L8.87775 6.2519C8.91839 6.21115 8.96667 6.17883 9.01982 6.15677C9.07297 6.13472 9.12995 6.12336 9.1875 6.12336C9.24505 6.12336 9.30203 6.13472 9.35518 6.15677C9.40833 6.17883 9.45661 6.21115 9.49725 6.2519Z",
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0625 -0.000854492C3.17853 -0.000854492 3.28981 0.0452391 3.37186 0.127286C3.45391 0.209333 3.5 0.320613 3.5 0.436646V0.874146H10.5V0.436646C10.5 0.320613 10.5461 0.209333 10.6281 0.127286C10.7102 0.0452391 10.8215 -0.000854492 10.9375 -0.000854492C11.0535 -0.000854492 11.1648 0.0452391 11.2469 0.127286C11.3289 0.209333 11.375 0.320613 11.375 0.436646V0.874146H12.25C12.7141 0.874146 13.1592 1.05852 13.4874 1.38671C13.8156 1.7149 14 2.16002 14 2.62415V12.2491C14 12.7133 13.8156 13.1584 13.4874 13.4866C13.1592 13.8148 12.7141 13.9991 12.25 13.9991H1.75C1.28587 13.9991 0.840752 13.8148 0.512563 13.4866C0.184374 13.1584 0 12.7133 0 12.2491V2.62415C0 2.16002 0.184374 1.7149 0.512563 1.38671C0.840752 1.05852 1.28587 0.874146 1.75 0.874146H2.625V0.436646C2.625 0.320613 2.67109 0.209333 2.75314 0.127286C2.83519 0.0452391 2.94647 -0.000854492 3.0625 -0.000854492ZM0.875 3.49915V12.2491C0.875 12.4812 0.967187 12.7038 1.13128 12.8679C1.29538 13.032 1.51794 13.1241 1.75 13.1241H12.25C12.4821 13.1241 12.7046 13.032 12.8687 12.8679C13.0328 12.7038 13.125 12.4812 13.125 12.2491V3.49915H0.875Z",
    fill: "#6C757D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2021_411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/date-picker.8f4f0b02f056a9eb1c1d9ccb9e4b5eeb.svg";
export { ForwardRef as ReactComponent };